// In development, use empty string to leverage the proxy (see src/setupProxy.js)
// In production, use the environment variable
const baseUrl = import.meta.env.VITE_CITIZEN_API_URL || '';

export const CITIZEN_API_URL = baseUrl;
